<script lang="ts" setup>
  import { ToastPresenter } from '@tundr/toast';
  import { GLOBAL_OVERLAYS_TARGET } from '@tundr/ds-components';
  import { Modal } from '@tundr/modal';
  import { Slideover } from '@tundr/slideover';
</script>

<template>
  <div :class="GLOBAL_OVERLAYS_TARGET" />
  <Modal />
  <ToastPresenter />
  <Slideover />
</template>
